import * as React from 'react'

const SvgMathematicsIcon = (props) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="10" fill="#444CE7" />
    <path
      d="M30.5708 32C31.8328 32 32.8568 30.977 32.8568 29.714V25.143L33.9998 24L32.8568 22.857V18.286C32.8568 17.023 31.8338 16 30.5708 16M17.429 16C16.166 16 15.143 17.023 15.143 18.286V22.857L14 24L15.143 25.143V29.714C15.143 30.977 16.166 32 17.429 32M24 20V28M20 24H28"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgMathematicsIcon
